import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import styles from "./styles.m.css";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";
import { generateImageSources, getStoryData, checkAppSlug } from "../../utils/utils";
import { isPremium } from "../../../../isomorphic/data/story";
import ReadMoreLink from "../../rows/readmore-link";

const StorySpecialItem = ({ story, cardWithImageZoom = true, className = "", hasTruncatedHeadline = true }) => {
  const storyData = getStoryData(story, true);
  const externalLink = get(story, ["metadata", "reference-url"]);

  if (!(storyData.headline && story.url)) {
    return null;
  }

  const checkSlug = checkAppSlug();
  let SourceLink = "";
  if (checkSlug) {
    SourceLink = externalLink || story.url;
  }

  return (
    <Link
      aria-label={`${"Read full story: "} ${storyData.headline}`}
      className={`${styles["read-more-link"]} ${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""}`}
      href={externalLink || story.url}
      externalLink={SourceLink}
    >
      <h3 className={styles["headline"]}>{storyData.headline}</h3>
      <ResponsiveImageWithFallback
        className={styles["image-wrapper"]}
        slug={storyData.imageS3Key}
        metadata={storyData.imageMetadata}
        isPremium={isPremium(story)}
        alt={storyData.imageCaption}
        imgParams={{ auto: ["format", "compress"] }}
        sources={generateImageSources(
          { aspectRatio: [7, 8], screenWidthCoverage: 0.6 },
          { aspectRatio: [7, 8], screenWidthCoverage: 0.3 }
        )}
      />
      <div className={styles["content-wrap"]}>
        {story.subheadline && <p className={styles["summary"]}>{story.subheadline}</p>}
        <ReadMoreLink className="special" href={externalLink || story.url} externalLink={true} />
      </div>
    </Link>
  );
};

StorySpecialItem.propTypes = {
  cardWithImageZoom: PropTypes.bool,
  className: PropTypes.string,
  hasTruncatedHeadline: PropTypes.bool,
  story: PropTypes.shape({
    id: PropTypes.string,
    authors: PropTypes.arrayOf(
      PropTypes.shape({
        "contributor-role": PropTypes.shape({
          name: PropTypes.string
        }),
        name: PropTypes.string
      })
    ),
    headline: PropTypes.string.isRequired,
    subheadline: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "reference-url": PropTypes.string
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          headline: PropTypes.string
        })
      })
    }),
    slug: PropTypes.string.isRequired,
    "hero-image-metadata": PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
      "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
    }),
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string
  })
};

export default StorySpecialItem;
